export const LOGIN_URL = "auth";
export const FORGET_PASSWORD_URL = "auth/forgot-pwd";
